import React, { useState } from 'react';
import { cn } from '@/lib/utils';

interface MediumStyleEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const MediumStyleEditor: React.FC<MediumStyleEditorProps> = ({
  value,
  onChange,
  placeholder = 'Start writing...',
  className,
}) => {
  const [saveStatus, setSaveStatus] = useState('Saved');

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setSaveStatus('Saving...');
    onChange(e.target.value);
    
    // Debounce the save status
    setTimeout(() => {
      setSaveStatus('Saved');
    }, 300);
  };

  return (
    <div className={cn('relative w-full', className)}>
      <textarea
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className="relative min-h-[300px] w-full max-w-screen-lg border border-input bg-background rounded-lg p-4 focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-none resize-none text-sm leading-relaxed font-medium"
        style={{ 
          fontFamily: 'system-ui, -apple-system, sans-serif',
          lineHeight: '1.6'
        }}
      />
      
      <div className="absolute bottom-2 right-2 text-xs text-muted-foreground">
        {saveStatus}
      </div>
    </div>
  );
};

export default MediumStyleEditor;